import React from 'react'
import createReactClass from 'create-react-class'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table'
import Pagination from 'react-js-pagination'
import ErrorBlock from '../../elements/error-block'
import {AnalysisFormData} from '../../util/helpers'
import './analysis-result-panel.scss'
import '../search-page/search-result.scss'
import {mapObjIndexed} from 'ramda'
import ShowExtraTextPanel from '../show-extra-text-panel'

export default createReactClass({
  getInitialState () {
    return {
      sizeError: '',
      showModal: false,
      showText: '',
      columnName: '',
    }
  },

  getColumns () {
    if (this.props.columns.length > 0) {
      return this.props.columns
    } else {
      let headerNames = []
      for (let i = 0; i <= this.props.logs.length; i++) {
        for (let key in this.props.logs[i]) {
          if (headerNames.indexOf(key) === -1) {
            headerNames.push(key)
          }
        }
      }
      return headerNames
    }
  },
  rowFormatter (cell, row) {
    if (typeof cell === 'object' && !Array.isArray(cell) && cell !== null) {
      return <div title={cell.simpleValue}>{cell.simpleValue ? <span>{cell.simpleValue}</span> : <span></span>}</div>
    } else {
      if (cell && cell.length > 500) {
        return <div title={cell}>{cell ? <span>{cell.substring(0, 252) + '  ........'}</span> : <span>-</span>}</div>
      } else {
        return <div title={cell}>{cell ? <span>{cell}</span> : <span>-</span>}</div>
      }
    }
  },
  getWidth (key) {
    if (key === 'cId' || key === 'logSource') {
      return '400'
    } else if (key === 'message') {
      return '400'
    } else if (key === 'productId' || key === 'logType' || key === 'logLevel') {
      return '100'
    }
    return '120'
  },
  requestReport (cell, row) {
    return (
      <button className="btn btn-info" title="Request Report" onClick={this.showReport.bind(this, row.id)}>
        <span className="glyphicon glyphicon-file"></span>
      </button>
    )
  },
  handlePageChange (pageNumber) {
    this.props.onPageChange(pageNumber)
    this.props.getLogs(this.props, pageNumber, this.props.pageSize)
  },
  handlePageSizeChange (e) {
    let pageSize = +e.target.value
    if (pageSize <= AnalysisFormData.maxPageSize && pageSize !== 0) {
      this.props.onPageSizeChange(pageSize)
      this.props.getLogs(this.props, this.props.pageNo, pageSize)
      this.setState({sizeError: ''})
    } else if (pageSize > AnalysisFormData.maxPageSize) {
      this.setState({sizeError: `Max page size is ${AnalysisFormData.maxPageSize}`})
    }
  },
  showModal (row) {
    mapObjIndexed((r, key) => {
      if (r && r.length > 400) {
        this.setState((prevState) => {
          return {
            showModal: true,
            showText: r,
            columnName: key,
          }
        })
      }
    }, row)
  },
  closeModal () {
    this.setState({
      showModal: false,
    })
  },
  render () {
    const options = {
      onRowClick: this.showModal,
    }
    return (
      <div className="search-result-panel">
        {this.props.loader
          ? <div className='loader-ctr'><span className="loading"></span></div>
          : <div>
            {this.props.error.message
              ? <ErrorBlock {...this.props.error}/>
              : <div className="cs-search-table">
                <BootstrapTable data={this.props.logs} keyField='cId' striped hover condensed
                  maxHeight="800px" trClassName='bootstrap-table-tr' options={options}>
                  {this.getColumns().map((column, index) =>
                    <TableHeaderColumn dataField={column} dataAlign='center' width={this.getWidth(column)}
                      key={index} dataFormat={this.rowFormatter}>
                      {(column === 'clientAddress') ? 'Ip Address'
                        : (column.substring(0, 1).toUpperCase() + column.substring(1)).split(/(?=[A-Z])/).join(' ')}
                    </TableHeaderColumn>)}
                </BootstrapTable>
              </div>
            }
            <div>
              {this.props.totalSize > this.props.pageSize
                ? <div>
                  <div className='page-size-block'>
                    <input type='number' placeholder='Page Size'
                      defaultValue={this.props.pageSize}
                      onBlur={this.handlePageSizeChange}/>
                    {this.state.sizeError ? this.state.sizeError : null}
                  </div>
                  <Pagination
                    activePage={this.props.pageNo}
                    itemsCountPerPage={this.props.pageSize}
                    totalItemsCount={this.props.totalSize}
                    pageRangeDisplayed={this.props.pageRange}
                    onChange={this.handlePageChange}/>
                </div>
                : null
              }
            </div>
            {this.state.showModal && <div><ShowExtraTextPanel showModal = {this.state.showModal}
              text={this.state.showText} title={this.state.columnName} closeModal={this.closeModal}/></div>
            }
          </div>
        }
      </div>
    )
  },
  componentWillReceiveProps (nextProps) {
    this.closeModal()
  },
})



// WEBPACK FOOTER //
// ./src/components/analysis-page/analysis-result-panel.js